import './CheckButton.less';

import React, { FC, FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import clsx from 'clsx';
import ActiveCheckbox from '../../icons/svg/active-checkbox-sv.svg';

interface CheckButtonProps {
    active?: boolean;
    className?: string;
    disabled?: boolean;
    icon?: FunctionComponent;
    children?: ReactNode;
    onClick: MouseEventHandler;
}

const CheckButton: FC<CheckButtonProps> = ({ active, disabled, className = null, onClick, children, ...rest }) => (
    <div
        className={clsx('nui-check-button', className, { active, disabled })}
        onClick={e => !disabled && onClick && onClick(e)}
        {...rest}
    >
        {active ? <ActiveCheckbox /> : <div className="nui-check-icon nui-fake-check" />}
        {children}
    </div>
);

export default CheckButton;
